// Contrast-safe variants of the shared avatar palette (PARITY P255). The palette itself stays
// byte-for-byte AvatarIdentity's (a person is the same hue on every client); on the web the
// initials disc and the author name read through per-index tokens in design/tokens.css that are
// measured to WCAG AA (4.5:1) — the disc darkened for white initials, the name per theme.
import { AvatarIdentity } from '../core/avatarIdentity';

const index = new Map(AvatarIdentity.palette.map((hex, i) => [hex.toLowerCase(), i]));

/** The initials disc's background for a palette colour (any other colour passes through). */
export function faceBackground(hex: string): string {
  const i = index.get(hex.toLowerCase());
  return i === undefined ? hex : `var(--avatar-face-${i}, ${hex})`;
}

/** An author name's colour on the bubble for a palette colour, per theme. */
export function nameColor(hex: string): string {
  const i = index.get(hex.toLowerCase());
  return i === undefined ? hex : `var(--name-${i}, ${hex})`;
}
